
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('InvestorDocumentSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let ProjectSections = Parse.Object.extend('Investor_Documents');

		// Define 'Project_Sections' scheme
		let schema = [
			'name',
			'type',
			'file',
			'Project'
		];
		
		// Load schema into object prototype
		schema.forEach(field => {
			Object.defineProperty(ProjectSections.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return ProjectSections;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/schemas/investment-document.schema.js